// extracted by mini-css-extract-plugin
export default {"icon-button":"IconButton_icon-button__q69dw","interactive":"IconButton_interactive__Y0bDc"};